export default function SmartPhoneIcon({ size }: { size?: string }) {
  return (
    <svg
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      width={size || "12"}
      height={size || "12"}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 2.37998V15.62H13V2.37998H5ZM4.37153 0.900002H13.6287C13.8333 0.900002 14.0295 0.985341 14.1742 1.13725C14.3188 1.28915 14.4001 1.49518 14.4001 1.71V16.29C14.4001 16.5048 14.3188 16.7109 14.1742 16.8628C14.0295 17.0147 13.8333 17.1 13.6287 17.1H4.37153C4.16693 17.1 3.97071 17.0147 3.82604 16.8628C3.68137 16.7109 3.6001 16.5048 3.6001 16.29V1.71C3.6001 1.49518 3.68137 1.28915 3.82604 1.13725C3.97071 0.985341 4.16693 0.900002 4.37153 0.900002Z"
        fill="#A0A3BD"
      />
      <path
        d="M6.75 12.75C6.33579 12.75 6 13.0858 6 13.5C6 13.9142 6.33579 14.25 6.75 14.25V12.75ZM11.25 14.25C11.6642 14.25 12 13.9142 12 13.5C12 13.0858 11.6642 12.75 11.25 12.75V14.25ZM6.75 14.25H11.25V12.75H6.75V14.25Z"
        fill="#A0A3BD"
      />
    </svg>
  );
}
